/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { themeV2 } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPANDABLE SECTION - SECTION DESC : STYLES --------------- ++++++++++ */
export default theme => ({
  sectiondescription: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& h5': {
      display: props => !!props.main ? 'block' : 'none',
      textTransform: props => !!props.main ? 'capitalize' : 'none'
    },
    '& h6': {
      display: props => !!props.additional ? 'block' : 'none',
      color: themeV2.color.base.gray.dark
    }
  }
});
